
import React, { createContext, useContext, useState, useEffect } from "react";
import apiServiceInv from "../services/apiService";

const CurrencyContext = createContext();

const REFRESH_INTERVAL = 3600000; // 1 hour

// Instantiate the apiService outside the component to avoid re-creation on re-renders.
const apiService = new apiServiceInv();

export const CurrencyProvider = ({ children }) => {
  const [defaultCurrency, setDefaultCurrency] = useState(null);
  const [currencyPrecision, setCurrencyPrecision] = useState(2); // Default precision
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // ========== Fetch Currency Precision ==========
  const handleCurrencies = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = JSON.parse(localStorage.getItem("currencylist")) || [];
      const newDefaultCurrency = data?.find((comp) => comp.isDefault === true);
      if (newDefaultCurrency) {
        setDefaultCurrency(newDefaultCurrency);
        setCurrencyPrecision(newDefaultCurrency.exp1 || 3);
      } else {
        // Handle case where no default currency is found
        setError("Default currency not found.");
      }
    } catch (error) {
      console.error("Failed to fetch currency precision:", error);
      setError("Failed to fetch currency settings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleCurrencies();

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        handleCurrencies();
      }
    };

    const interval = setInterval(handleCurrencies, REFRESH_INTERVAL);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <CurrencyContext.Provider
      value={{
        defaultCurrency,
        currencyPrecision,
        loading,
        error,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
